const etbs = [
  {
    name: "30th Celebration",
    glb: "https://cdn.shopify.com/3d/models/198742487ffee170/30th_celebration.glb",
    image: "https://cdn.shopify.com/s/files/1/0933/4046/7564/files/30th_Celebration.png?v=1782867603"
  },
  {
    name: "30th Celebration (Pokémon Center)",
    glb: "https://cdn.shopify.com/3d/models/c6b2c0643bf129a1/30th_celebration_pc.glb",
    image: "https://cdn.shopify.com/s/files/1/0933/4046/7564/files/30th_Celebration_PC.png?v=1782867603"
  },
  {
    name: "151",
    glb: "https://cdn.shopify.com/3d/models/ff007c19c8c4598d/151.glb",
    image: "https://cdn.shopify.com/s/files/1/0933/4046/7564/files/151.png?v=1753580331"
  },
  {
    name: "151 (Pokémon Center)",
    glb: "https://cdn.shopify.com/3d/models/4a46fa03160c208e/151_pc.glb",
    image: "https://cdn.shopify.com/s/files/1/0933/4046/7564/files/151pc.png?v=1753580337"
  },
  {
    name: "Ancient Origins",
    glb: "https://cdn.shopify.com/3d/models/5af2e3cf36608dbc/ancient_origins.glb",
    image: "https://cdn.shopify.com/s/files/1/0933/4046/7564/files/ancient_origins.png?v=1753580342"
  },
  {
    name: "Ascended Heroes",
    glb: "https://cdn.shopify.com/3d/models/5679b40bab3ae6c2/ascended_heroes.glb",
    image: "https://cdn.shopify.com/s/files/1/0933/4046/7564/files/Ascended_Heroes.png?v=1763587126"
  },
  {
    name: "Ascended Heroes (Pokémon Center)",
    glb: "https://cdn.shopify.com/3d/models/092246e4745b9c7b/ascended_heroes_pc.glb",
    image: "https://cdn.shopify.com/s/files/1/0933/4046/7564/files/Ascended_Heroes_PC.png?v=1765850177"
  },
  {
    name: "Astral Radiance",
    glb: "https://cdn.shopify.com/3d/models/55637a41c034f0f0/astral.glb",
    image: "https://cdn.shopify.com/s/files/1/0933/4046/7564/files/astral_radiance.png?v=1753580333"
  },
  {
    name: "Astral Radiance (Pokémon Center)",
    glb: "https://cdn.shopify.com/3d/models/963140ff19a22340/astral_pc.glb",
    image: "https://cdn.shopify.com/s/files/1/0933/4046/7564/files/astral_radiancepc.png?v=1753580335"
  },
  {
    name: "Battle Styles [Rapid Strike Urshifu]",
    glb: "https://cdn.shopify.com/3d/models/6d4f3fc4f9864f54/battlystyles_blue.glb",
    image: "https://cdn.shopify.com/s/files/1/0933/4046/7564/files/battle_styles2.png?v=1753580341"
  },
  {
    name: "Battle Styles [Single Strike Urshifu]",
    glb: "https://cdn.shopify.com/3d/models/81a00264479f2a17/battlystyles_red.glb",
    image: "https://cdn.shopify.com/s/files/1/0933/4046/7564/files/battle_styles1.png?v=1753580344"
  },
  {
    name: "Black Bolt",
    glb: "https://cdn.shopify.com/3d/models/c4264b816a4a31f0/black_bolt.glb",
    image: "https://cdn.shopify.com/s/files/1/0933/4046/7564/files/black_bolt.png?v=1753580341"
  },
  {
    name: "Black Bolt (Pokémon Center)",
    glb: "https://cdn.shopify.com/3d/models/cf5619ce00d23f2b/black_bolt_pc.glb",
    image: "https://cdn.shopify.com/s/files/1/0933/4046/7564/files/black_bolt_pc.png?v=1753580325"
  },
  {
    name: "Breakpoint",
    glb: "https://cdn.shopify.com/3d/models/80e18953c77d9c5f/breakpoint.glb",
    image: "https://cdn.shopify.com/s/files/1/0933/4046/7564/files/breakpoint.png?v=1753580349"
  },
  {
    name: "Breakthrough [Mewtwo Y]",
    glb: "https://cdn.shopify.com/3d/models/0722104902b50cde/break_through_pink.glb",
    image: "https://cdn.shopify.com/s/files/1/0933/4046/7564/files/break_through_pink.png?v=1753580349"
  },
  {
    name: "Breakthrough [Mewtwo X]",
    glb: "https://cdn.shopify.com/3d/models/5016a0f524f57eda/break_through_purple.glb",
    image: "https://cdn.shopify.com/s/files/1/0933/4046/7564/files/break_through_purple.png?v=1753580346"
  },
  {
    name: "Brilliant Stars",
    glb: "https://cdn.shopify.com/3d/models/dd0afe30e9e7db7c/brilliant.glb",
    image: "https://cdn.shopify.com/s/files/1/0933/4046/7564/files/brilliant_stars.png?v=1753580313"
  },
  {
    name: "Brilliant Stars (Pokémon Center)",
    glb: "https://cdn.shopify.com/3d/models/f4e27ae16854ee5c/brilliant_pc.glb",
    image: "https://cdn.shopify.com/s/files/1/0933/4046/7564/files/brilliant_stars_pc.png?v=1753580349"
  },
  {
    name: "Burning Shadows",
    glb: "https://cdn.shopify.com/3d/models/3f80a06bfd11fdb5/burning_shadows.glb",
    image: "https://cdn.shopify.com/s/files/1/0933/4046/7564/files/burning_shadows.png?v=1753580343"
  },
  {
    name: "Celebrations",
    glb: "https://cdn.shopify.com/3d/models/8f2779c5215acb3b/celebrations.glb",
    image: "https://cdn.shopify.com/s/files/1/0933/4046/7564/files/celebrations_800x_1d535e22-528d-42b0-9f10-b118a402cb38.png?v=1753580314"
  },
  {
    name: "Celestial Storm",
    glb: "https://cdn.shopify.com/3d/models/c43f1ec7791e7845/celestial.glb",
    image: "https://cdn.shopify.com/s/files/1/0933/4046/7564/files/celestial_storm.png?v=1753580346"
  },
  {
    name: "Champion’s Path",
    glb: "https://cdn.shopify.com/3d/models/5a29fc3f3e618f50/champpath.glb",
    image: "https://cdn.shopify.com/s/files/1/0933/4046/7564/files/champpath.png?v=1753580337"
  },
  {
    name: "Chaos Rising",
    glb: "https://cdn.shopify.com/3d/models/1b54bec853488bdf/chaos_rising.glb",
    image: "https://cdn.shopify.com/s/files/1/0933/4046/7564/files/Chaos_Rising.png?v=1773365710"
  },
  {
    name: "Chaos Rising (Pokémon Center)",
    glb: "https://cdn.shopify.com/3d/models/7fc7ec41b8295dfe/chaos_rising_pkc.glb",
    image: "https://cdn.shopify.com/s/files/1/0933/4046/7564/files/Chaos_Rising_PKC.png?v=1773365709"
  },
  {
    name: "Chilling Reign [Ice Rider Calyrex]",
    glb: "https://cdn.shopify.com/3d/models/0489694b9c14cceb/chilling_blue_pc.glb",
    image: "https://cdn.shopify.com/s/files/1/0933/4046/7564/files/chilling_blue.png?v=1753580335"
  },
  {
    name: "Chilling Reign [Ice Rider Calyrex] (Pokémon Center)",
    glb: "https://cdn.shopify.com/3d/models/75228bf6eb822ae7/chilling_blue_pc.glb",
    image: "https://cdn.shopify.com/s/files/1/0933/4046/7564/files/chilling_blue_pc.png?v=1753580338"
  },
  {
    name: "Chilling Reign [Shadow Rider Calyrex]",
    glb: "https://cdn.shopify.com/3d/models/b7fc3cbf93dd4533/chilling_purp.glb",
    image: "https://cdn.shopify.com/s/files/1/0933/4046/7564/files/chilling_purple.png?v=1753580334"
  },
  {
    name: "Chilling Reign [Shadow Rider Calyrex] (Pokémon Center)",
    glb: "https://cdn.shopify.com/3d/models/249ce783f4f38282/chilling_purp_pc.glb",
    image: "https://cdn.shopify.com/s/files/1/0933/4046/7564/files/chilling_purple_pc.png?v=1753580346"
  },
  {
    name: "Cosmic Eclipse",
    glb: "https://cdn.shopify.com/3d/models/cb3db8c556a3c69c/cosmic_eclipse.glb",
    image: "https://cdn.shopify.com/s/files/1/0933/4046/7564/files/cosmic_eclipse.png?v=1753580357"
  },
  {
    name: "Crimson Invasion",
    glb: "https://cdn.shopify.com/3d/models/e861623b83bb8ce6/crimson_invasion.glb",
    image: "https://cdn.shopify.com/s/files/1/0933/4046/7564/files/crimson_invasion.png?v=1753580349"
  },
  {
    name: "Crown Zenith",
    glb: "https://cdn.shopify.com/3d/models/6e0d4f07533cc240/crownzenith.glb",
    image: "https://cdn.shopify.com/s/files/1/0933/4046/7564/files/crownz.png?v=1753580348"
  },
  {
    name: "Darkness Ablaze",
    glb: "https://cdn.shopify.com/3d/models/6a561bd03db4edc2/darkness.glb",
    image: "https://cdn.shopify.com/s/files/1/0933/4046/7564/files/darknessablaze.png?v=1753580341"
  },
  {
    name: "Delta Reign",
    glb: "https://cdn.shopify.com/3d/models/65ec9a02d3f64f87/delta_reign.glb",
    image: "https://cdn.shopify.com/s/files/1/0933/4046/7564/files/Delta_reign.png?v=1787324353"
  },
  {
    name: "Delta Reign (Pokémon Center)",
    glb: "https://cdn.shopify.com/3d/models/0906c066b2b4d877/delta_reign_pc.glb",
    image: "https://cdn.shopify.com/s/files/1/0933/4046/7564/files/Delta_reign_PC.png?v=1787324353"
  },
  {
    name: "Destined Rivals",
    glb: "https://cdn.shopify.com/3d/models/815f1800ca703dd4/dr.glb",
    image: "https://cdn.shopify.com/s/files/1/0933/4046/7564/files/dr.png?v=1753580320"
  },
  {
    name: "Destined Rivals (Pokémon Center)",
    glb: "https://cdn.shopify.com/3d/models/beb17fe4031c365f/dr_pc.glb",
    image: "https://cdn.shopify.com/s/files/1/0933/4046/7564/files/dr_pc.png?v=1753580334"
  },
  {
    name: "Dragon Majesty",
    glb: "https://cdn.shopify.com/3d/models/e906e4eb81209e4b/dragon_majesty.glb",
    image: "https://cdn.shopify.com/s/files/1/0933/4046/7564/files/dragon_majesty.png?v=1753660283"
  },
  {
    name: "Evolutions [Blastoise]",
    glb: "https://cdn.shopify.com/3d/models/98d917a4fb023f7a/evolutions_blue.glb",
    image: "https://cdn.shopify.com/s/files/1/0933/4046/7564/files/evolutions_blue.png?v=1753580343"
  },
  {
    name: "Evolutions [Charizard]",
    glb: "https://cdn.shopify.com/3d/models/8d17a5825f1bb228/evolutions_red.glb",
    image: "https://cdn.shopify.com/s/files/1/0933/4046/7564/files/evolutions_red.png?v=1753580348"
  },
  {
    name: "Evolving Skies [F/J/U/L]",
    glb: "https://cdn.shopify.com/3d/models/fbfadeb792f8324c/evoLUJF.glb",
    image: "https://cdn.shopify.com/s/files/1/0933/4046/7564/files/evo_etb_LUJF_8c94f522-85bb-4e73-b2bd-a4ea0c3ed960.png?v=1753593630"
  },
  {
    name: "Evolving Skies [F/J/U/L] (Pokémon Center)",
    glb: "https://cdn.shopify.com/3d/models/602577ec119c29d6/evoLUJF_pc.glb",
    image: "https://cdn.shopify.com/s/files/1/0933/4046/7564/files/evo_etb_LUJF_pc_51e41389-366b-48b2-9abe-d3787720ae6d.png?v=1753593642"
  },
  {
    name: "Evolving Skies [G/V/S/E]",
    glb: "https://cdn.shopify.com/3d/models/cef58772b3a78b7b/evoSUGV.glb",
    image: "https://cdn.shopify.com/s/files/1/0933/4046/7564/files/evoSUGV.png?v=1753580330"
  },
  {
    name: "Evolving Skies [G/V/S/E] (Pokémon Center)",
    glb: "https://cdn.shopify.com/3d/models/486cf2707b84f824/evoSUGV_pc.glb",
    image: "https://cdn.shopify.com/s/files/1/0933/4046/7564/files/evoSUGV_pc.png?v=1753580352"
  },
  {
    name: "Fates Collide",
    glb: "https://cdn.shopify.com/3d/models/594229d1b4bf5ca2/fates_collide.glb",
    image: "https://cdn.shopify.com/s/files/1/0933/4046/7564/files/fates_collide.png?v=1753580348"
  },
  {
    name: "Forbidden Light",
    glb: "https://cdn.shopify.com/3d/models/19fbcee558822cc6/forbidden_light.glb",
    image: "https://cdn.shopify.com/s/files/1/0933/4046/7564/files/forbidden_light.png?v=1753580344"
  },
  {
    name: "Furious Fists",
    glb: "https://cdn.shopify.com/3d/models/7db35326629ffe43/furious_fists.glb",
    image: "https://cdn.shopify.com/s/files/1/0933/4046/7564/files/furious_fists.png?v=1753580340"
  },
  {
    name: "Fusion Strike",
    glb: "https://cdn.shopify.com/3d/models/bf39bf3530bd072f/fusion.glb",
    image: "https://cdn.shopify.com/s/files/1/0933/4046/7564/files/fusion.png?v=1753580314"
  },
  {
    name: "Fusion Strike (Pokémon Center)",
    glb: "https://cdn.shopify.com/3d/models/d0c55629dbed875d/fusion_pc.glb",
    image: "https://cdn.shopify.com/s/files/1/0933/4046/7564/files/fusion_strike.png?v=1753580347"
  },
  {
    name: "Generations",
    glb: "https://cdn.shopify.com/3d/models/571f242c9cd0c837/generations.glb",
    image: "https://cdn.shopify.com/s/files/1/0933/4046/7564/files/generations.png?v=1753580345"
  },
  {
    name: "Guardians Rising",
    glb: "https://cdn.shopify.com/3d/models/c5a8e5a3ba4b8e5d/guardians_rising.glb",
    image: "https://cdn.shopify.com/s/files/1/0933/4046/7564/files/guardians_rising.png?v=1753580349"
  },
  {
    name: "Hidden Fates",
    glb: "https://cdn.shopify.com/3d/models/6af7d11c484c5de0/hiddenfates.glb",
    image: "https://cdn.shopify.com/s/files/1/0933/4046/7564/files/hf.png?v=1753580343"
  },
  {
    name: "Journey Together",
    glb: "https://cdn.shopify.com/3d/models/0b5290c55a704e57/jt.glb",
    image: "https://cdn.shopify.com/s/files/1/0933/4046/7564/files/journey_center_reg.png?v=1753580361"
  },
  {
    name: "Journey Together (Pokémon Center)",
    glb: "https://cdn.shopify.com/3d/models/04bbf2741defbc33/jt_pc.glb",
    image: "https://cdn.shopify.com/s/files/1/0933/4046/7564/files/journey_center.png?v=1753580340"
  },
  {
    name: "Lost Origin",
    glb: "https://cdn.shopify.com/3d/models/32d4e499a3c97e1c/lost_origin.glb",
    image: "https://cdn.shopify.com/s/files/1/0933/4046/7564/files/lost_origin.png?v=1753580351"
  },
  {
    name: "Lost Origin (Pokémon Center)",
    glb: "https://cdn.shopify.com/3d/models/632cc6fb197b6533/lost_origin_pc.glb",
    image: "https://cdn.shopify.com/s/files/1/0933/4046/7564/files/lost_origin_pc.png?v=1753580346"
  },
  {
    name: "Lost Thunder",
    glb: "https://cdn.shopify.com/3d/models/153aae942d669c71/lost_thunder.glb",
    image: "https://cdn.shopify.com/s/files/1/0933/4046/7564/files/lost_thunder.png?v=1753580349"
  },
  {
    name: "Mega Evolutions [Gardevoir]",
    glb: "https://cdn.shopify.com/3d/models/5788347603995d14/mega_evo_gard.glb",
    image: "https://cdn.shopify.com/s/files/1/0933/4046/7564/files/mega_evo_gard.png?v=1754780964"
  },
  {
    name: "Mega Evolutions [Gardevoir] (Pokémon Center)",
    glb: "https://cdn.shopify.com/3d/models/275d97df933c395a/mega_evo_pkc_gard.glb",
    image: "https://cdn.shopify.com/s/files/1/0933/4046/7564/files/mega_evo_pkc_gard_transparent.png?v=1754781026"
  },
  {
    name: "Mega Evolutions [Lucario]",
    glb: "https://cdn.shopify.com/3d/models/29c4bd1a12aef501/mega_evo_lucario.glb",
    image: "https://cdn.shopify.com/s/files/1/0933/4046/7564/files/mega_evo_lucario.png?v=1754780964"
  },
  {
    name: "Mega Evolutions [Lucario] (Pokémon Center)",
    glb: "https://cdn.shopify.com/3d/models/998cf5c76d08fc64/mega_evo_pkc_lucario.glb",
    image: "https://cdn.shopify.com/s/files/1/0933/4046/7564/files/mega_evo_pkc_lucario_transparent.png?v=1754781026"
  },
  {
    name: "Obsidian Flames",
    glb: "https://cdn.shopify.com/3d/models/fb944583e5d4ff8c/oflames.glb",
    image: "https://cdn.shopify.com/s/files/1/0933/4046/7564/files/oflames.png?v=1753580350"
  },
  {
    name: "Obsidian Flames (Pokémon Center)",
    glb: "https://cdn.shopify.com/3d/models/bdac3ed117806fdd/oflames_pc.glb",
    image: "https://cdn.shopify.com/s/files/1/0933/4046/7564/files/oflamespc.png?v=1753580329"
  },
  {
    name: "Paldea Evolved",
    glb: "https://cdn.shopify.com/3d/models/b134ece155e6ecb6/paldea_evo.glb",
    image: "https://cdn.shopify.com/s/files/1/0933/4046/7564/files/paldea.png?v=1753580335"
  },
  {
    name: "Paldea Evolved (Pokémon Center)",
    glb: "https://cdn.shopify.com/3d/models/e8ac7b7baeaba1b3/paldea_evo_pc.glb",
    image: "https://cdn.shopify.com/s/files/1/0933/4046/7564/files/paldea_pc.png?v=1753580342"
  },
  {
    name: "Paldean Fates",
    glb: "https://cdn.shopify.com/3d/models/6acda462e9e09783/paldeanfates.glb",
    image: "https://cdn.shopify.com/s/files/1/0933/4046/7564/files/paldeanfates.png?v=1753580358"
  },
  {
    name: "Paldean Fates (Pokémon Center)",
    glb: "https://cdn.shopify.com/3d/models/3ba3e3bbf1ea4121/paldeanfates_pc.glb",
    image: "https://cdn.shopify.com/s/files/1/0933/4046/7564/files/paldeanfatespc.png?v=1753580344"
  },
  {
    name: "Paradox Rift [Roaring Moon]",
    glb: "https://cdn.shopify.com/3d/models/463c30c721d31ddf/paradox_blue.glb",
    image: "https://cdn.shopify.com/s/files/1/0933/4046/7564/files/paradox_rift2.png?v=1753580359"
  },
  {
    name: "Paradox Rift [Roaring Moon] (Pokémon Center)",
    glb: "https://cdn.shopify.com/3d/models/6a73d86cd6a5999b/paradox_blue_pc.glb",
    image: "https://cdn.shopify.com/s/files/1/0933/4046/7564/files/paradox_riftpc2.png?v=1753580340"
  },
  {
    name: "Paradox Rift [Iron Valiant]",
    glb: "https://cdn.shopify.com/3d/models/574e41d3c08b1f5d/paradox_green.glb",
    image: "https://cdn.shopify.com/s/files/1/0933/4046/7564/files/paradox_rift.png?v=1753580358"
  },
  {
    name: "Paradox Rift [Iron Valiant] (Pokémon Center)",
    glb: "https://cdn.shopify.com/3d/models/3249e4ce7e17924b/paradox_green_pc.glb",
    image: "https://cdn.shopify.com/s/files/1/0933/4046/7564/files/paradox_riftpc.png?v=1753580339"
  },
  {
    name: "Perfect Order",
    glb: "https://cdn.shopify.com/3d/models/67b1186f0601cd23/perfect_order.glb",
    image: "https://cdn.shopify.com/s/files/1/0933/4046/7564/files/Perfect_Order.png?v=1767810898"
  },
  {
    name: "Perfect Order (Pokémon Center)",
    glb: "https://cdn.shopify.com/3d/models/6601c7a3c52e70c6/perfect_order_pc.glb",
    image: "https://cdn.shopify.com/s/files/1/0933/4046/7564/files/Perfect_Order_PC.png?v=1768238537"
  },
  {
    name: "Phantasmal Flames",
    glb: "https://cdn.shopify.com/3d/models/ee9ba1e480e11d2f/Phantasmal_Flames.glb",
    image: "https://cdn.shopify.com/s/files/1/0933/4046/7564/files/Phantasmal-Flames-ETB.png?v=1757636067"
  },
  {
    name: "Phantasmal Flames (Pokémon Center)",
    glb: "https://cdn.shopify.com/3d/models/c98e7672ab4986f3/Phantasmal_Flames_PC.glb",
    image: "https://cdn.shopify.com/s/files/1/0933/4046/7564/files/Phantasmal_Flames_PKC.png?v=1757636065"
  },
  {
    name: "Phantom Forces",
    glb: "https://cdn.shopify.com/3d/models/def0c157daa5df8d/phantom_forces.glb",
    image: "https://cdn.shopify.com/s/files/1/0933/4046/7564/files/phantom_forces.png?v=1753580326"
  },
  {
    name: "Pitch Black",
    glb: "https://cdn.shopify.com/3d/models/28ec390303f71d50/pitch_black.glb",
    image: "https://cdn.shopify.com/s/files/1/0933/4046/7564/files/pitch_black.png?v=1777585762"
  },
  {
    name: "Pitch Black (Pokémon Center)",
    glb: "https://cdn.shopify.com/3d/models/e2f520768622bf69/pitch_black_pc.glb",
    image: "https://cdn.shopify.com/s/files/1/0933/4046/7564/files/pitch_black_pc.png?v=1777585763"
  },
  {
    name: "Plasma Blast",
    glb: "https://cdn.shopify.com/3d/models/7110c8b83ea6694d/plasma_blast.glb",
    image: "https://cdn.shopify.com/s/files/1/0933/4046/7564/files/plasma_blast.png?v=1753659502"
  },
  {
    name: "Plasma Storm",
    glb: "https://cdn.shopify.com/3d/models/e946da637a59bd72/plasma_storm.glb",
    image: "https://cdn.shopify.com/s/files/1/0933/4046/7564/files/plasma_storm.png?v=1753580347"
  },
  {
    name: "Pokémon GO",
    glb: "https://cdn.shopify.com/3d/models/1a89f4d4d9fcac63/go.glb",
    image: "https://cdn.shopify.com/s/files/1/0933/4046/7564/files/go_etb.png?v=1753580351"
  },
  {
    name: "Primal Clash [Kyogre]",
    glb: "https://cdn.shopify.com/3d/models/725e08e50d5cafa0/primal_clash_blue.glb",
    image: "https://cdn.shopify.com/s/files/1/0933/4046/7564/files/primal_clash_blue.png?v=1753580343"
  },
  {
    name: "Primal Clash [Groudon]",
    glb: "https://cdn.shopify.com/3d/models/d0f34c020d565a8c/primal_clash_red.glb",
    image: "https://cdn.shopify.com/s/files/1/0933/4046/7564/files/primal_clash_red.png?v=1753580350"
  },
  {
    name: "Prismatic Evolutions",
    glb: "https://cdn.shopify.com/3d/models/e3b4586239d0bebb/prism.glb",
    image: "https://cdn.shopify.com/s/files/1/0933/4046/7564/files/prism.png?v=1753580352"
  },
  {
    name: "Prismatic Evolutions (Pokémon Center)",
    glb: "https://cdn.shopify.com/3d/models/1ec22611e38d808e/prism_pc.glb",
    image: "https://cdn.shopify.com/s/files/1/0933/4046/7564/files/prism_pc.png?v=1753580340"
  },
  {
    name: "Rebel Clash",
    glb: "https://cdn.shopify.com/3d/models/db986eb0a156b099/rebel_clash.glb",
    image: "https://cdn.shopify.com/s/files/1/0933/4046/7564/files/rebelclash.png?v=1753580343"
  },
  {
    name: "Roaring Skies",
    glb: "https://cdn.shopify.com/3d/models/90e268f8931cfb20/roaring_skies.glb",
    image: "https://cdn.shopify.com/s/files/1/0933/4046/7564/files/roaring_skies.png?v=1753580342"
  },
  {
    name: "Scarlet & Violet [Miraidon]",
    glb: "https://cdn.shopify.com/3d/models/5a9a795bf39925ea/sv_purple.glb",
    image: "https://cdn.shopify.com/s/files/1/0933/4046/7564/files/sv_purple.png?v=1753580348"
  },
  {
    name: "Scarlet & Violet [Miraidon] (Pokémon Center)",
    glb: "https://cdn.shopify.com/3d/models/2963b6eae5c02a31/sv_purple_pc.glb",
    image: "https://cdn.shopify.com/s/files/1/0933/4046/7564/files/sv_purple_pc.png?v=1753580331"
  },
  {
    name: "Scarlet & Violet [Koraidon]",
    glb: "https://cdn.shopify.com/3d/models/4dbef6cd9bcabad0/sv_red.glb",
    image: "https://cdn.shopify.com/s/files/1/0933/4046/7564/files/scarlet.png?v=1753580347"
  },
  {
    name: "Scarlet & Violet [Koraidon] (Pokémon Center)",
    glb: "https://cdn.shopify.com/3d/models/de0a8ba2a6a20706/sv_red_pc.glb",
    image: "https://cdn.shopify.com/s/files/1/0933/4046/7564/files/scarlet_pc.png?v=1753580336"
  },
  {
    name: "Shining Fates",
    glb: "https://cdn.shopify.com/3d/models/44b771fe5a70bc9e/shining_fates.glb",
    image: "https://cdn.shopify.com/s/files/1/0933/4046/7564/files/shining_fates.png?v=1753580352"
  },
  {
    name: "Shining Legends",
    glb: "https://cdn.shopify.com/3d/models/4787010e70fae50b/shining_legends.glb",
    image: "https://cdn.shopify.com/s/files/1/0933/4046/7564/files/shining_legends.png?v=1753580345"
  },
  {
    name: "Shrouded Fable",
    glb: "https://cdn.shopify.com/3d/models/3d2a629a8139f12f/fable.glb",
    image: "https://cdn.shopify.com/s/files/1/0933/4046/7564/files/fable.png?v=1753580350"
  },
  {
    name: "Shrouded Fable (Pokémon Center)",
    glb: "https://cdn.shopify.com/3d/models/6cdb985daae59d28/fable_pc.glb",
    image: "https://cdn.shopify.com/s/files/1/0933/4046/7564/files/fablepc.png?v=1753580349"
  },
  {
    name: "Silver Tempest",
    glb: "https://cdn.shopify.com/3d/models/ea7f6cd0c8d9eed5/silver_temp.glb",
    image: "https://cdn.shopify.com/s/files/1/0933/4046/7564/files/silver_tempest.png?v=1753580350"
  },
  {
    name: "Silver Tempest (Pokémon Center)",
    glb: "https://cdn.shopify.com/3d/models/44f5cbf415c9cdcd/silver_temp_pc.glb",
    image: "https://cdn.shopify.com/s/files/1/0933/4046/7564/files/silver_tempestpc.png?v=1753580334"
  },
  {
    name: "Steam Siege",
    glb: "https://cdn.shopify.com/3d/models/773e6f27973ac0f4/steam_siege.glb",
    image: "https://cdn.shopify.com/s/files/1/0933/4046/7564/files/steam_siege.png?v=1753580352"
  },
  {
    name: "Stellar Crown",
    glb: "https://cdn.shopify.com/3d/models/50466c71294bab3b/stellar_crown.glb",
    image: "https://cdn.shopify.com/s/files/1/0933/4046/7564/files/stellar_crown.png?v=1753580346"
  },
  {
    name: "Stellar Crown (Pokémon Center)",
    glb: "https://cdn.shopify.com/3d/models/d944fef82cdacfa2/stellar_crown_pc.glb",
    image: "https://cdn.shopify.com/s/files/1/0933/4046/7564/files/stellar_crownpc.png?v=1753580348"
  },
  {
    name: "Sun & Moon [Solgaleo]",
    glb: "https://cdn.shopify.com/3d/models/8a71f92e07dd6aaa/sun_moon_orange.glb",
    image: "https://cdn.shopify.com/s/files/1/0933/4046/7564/files/sun_moon_orange.png?v=1753580348"
  },
  {
    name: "Sun & Moon [Lunala]",
    glb: "https://cdn.shopify.com/3d/models/6247152bade0f632/sun_moon_purple.glb",
    image: "https://cdn.shopify.com/s/files/1/0933/4046/7564/files/sun_moon_purple.png?v=1753580345"
  },
  {
    name: "Surging Sparks",
    glb: "https://cdn.shopify.com/3d/models/8876f139e34db0f4/surging.glb",
    image: "https://cdn.shopify.com/s/files/1/0933/4046/7564/files/surging_sparks.png?v=1753580349"
  },
  {
    name: "Surging Sparks (Pokémon Center)",
    glb: "https://cdn.shopify.com/3d/models/b55a3f20d5503aae/surging_pc.glb",
    image: "https://cdn.shopify.com/s/files/1/0933/4046/7564/files/surging_sparks_pc.png?v=1753580337"
  },
  {
    name: "Sword & Shield [Zamazenta]",
    glb: "https://cdn.shopify.com/3d/models/8783a7bc04bc67f8/ssh_blue.glb",
    image: "https://cdn.shopify.com/s/files/1/0933/4046/7564/files/shield.png?v=1753580347"
  },
  {
    name: "Sword & Shield [Zacian]",
    glb: "https://cdn.shopify.com/3d/models/03c7faf28e1592a5/ssh_red.glb",
    image: "https://cdn.shopify.com/s/files/1/0933/4046/7564/files/sword.png?v=1753580343"
  },
  {
    name: "Team Up",
    glb: "https://cdn.shopify.com/3d/models/8cf6612182881593/teamup.glb",
    image: "https://cdn.shopify.com/s/files/1/0933/4046/7564/files/teamup.png?v=1753580346"
  },
  {
    name: "Temporal Forces [Walking Wake]",
    glb: "https://cdn.shopify.com/3d/models/662680dc76abad63/temporal_blue.glb",
    image: "https://cdn.shopify.com/s/files/1/0933/4046/7564/files/temporal_blue.png?v=1753580359"
  },
  {
    name: "Temporal Forces [Walking Wake] (Pokémon Center)",
    glb: "https://cdn.shopify.com/3d/models/8e2e2fb903312552/temporal_blue_pc.glb",
    image: "https://cdn.shopify.com/s/files/1/0933/4046/7564/files/temporal_blue_pc.png?v=1753580347"
  },
  {
    name: "Temporal Forces [Iron Leaves]",
    glb: "https://cdn.shopify.com/3d/models/d42b367962149645/temporal_green.glb",
    image: "https://cdn.shopify.com/s/files/1/0933/4046/7564/files/temporal_green.png?v=1753580360"
  },
  {
    name: "Temporal Forces [Iron Leaves] (Pokémon Center)",
    glb: "https://cdn.shopify.com/3d/models/ec9dcd231c2191d1/temporal_green_pc.glb",
    image: "https://cdn.shopify.com/s/files/1/0933/4046/7564/files/temporal_green_pc.png?v=1753580347"
  },
  {
    name: "Twilight Masquerade",
    glb: "https://cdn.shopify.com/3d/models/a1b8df75d5e76362/twilight.glb",
    image: "https://cdn.shopify.com/s/files/1/0933/4046/7564/files/twilight.png?v=1753580347"
  },
  {
    name: "Twilight Masquerade (Pokémon Center)",
    glb: "https://cdn.shopify.com/3d/models/d6e7377370451c72/twilight_pc.glb",
    image: "https://cdn.shopify.com/s/files/1/0933/4046/7564/files/twilightpc.png?v=1753580342"
  },
  {
    name: "Ultra Prism [Dawn Wings Necrozma]",
    glb: "https://cdn.shopify.com/3d/models/5f18695a402b79e4/ultra_prism_blue.glb",
    image: "https://cdn.shopify.com/s/files/1/0933/4046/7564/files/ultra_prism_blue.png?v=1753580334"
  },
  {
    name: "Ultra Prism [Dusk Mane Necrozma]",
    glb: "https://cdn.shopify.com/3d/models/4ae22dc238c725a1/ultra_prism_orange.glb",
    image: "https://cdn.shopify.com/s/files/1/0933/4046/7564/files/ultra_prism_orange.png?v=1753580339"
  },
  {
    name: "Unbroken Bonds",
    glb: "https://cdn.shopify.com/3d/models/24196b76787ec53f/unbroken_bonds.glb",
    image: "https://cdn.shopify.com/s/files/1/0933/4046/7564/files/unbroken_bonds.png?v=1753580345"
  },
  {
    name: "Unified Minds",
    glb: "https://cdn.shopify.com/3d/models/a8b061f70eb90f51/unified.glb",
    image: "https://cdn.shopify.com/s/files/1/0933/4046/7564/files/unified_minds.png?v=1753580347"
  },
  {
    name: "Vivid Voltage",
    glb: "https://cdn.shopify.com/3d/models/5a92f71fbfbfb8fa/vivid.glb",
    image: "https://cdn.shopify.com/s/files/1/0933/4046/7564/files/vivid.png?v=1753580343"
  },
  {
    name: "White Flare",
    glb: "https://cdn.shopify.com/3d/models/a55f92f50a46f2b5/white_flare.glb",
    image: "https://cdn.shopify.com/s/files/1/0933/4046/7564/files/white_flare.png?v=1753580336"
  },
  {
    name: "White Flare (Pokémon Center)",
    glb: "https://cdn.shopify.com/3d/models/ce787e41bd502be0/white_flare_pc.glb",
    image: "https://cdn.shopify.com/s/files/1/0933/4046/7564/files/white_flare_pc.png?v=1753580321"
  },
  {
    name: "XY [Xerneas]",
    glb: "https://cdn.shopify.com/3d/models/80fca918fae09d94/xy_blue.glb",
    image: "https://cdn.shopify.com/s/files/1/0933/4046/7564/files/xy_blue.png?v=1753580331"
  },
  {
    name: "XY [Yveltal]",
    glb: "https://cdn.shopify.com/3d/models/93e033029ebba4bf/xy_red.glb",
    image: "https://cdn.shopify.com/s/files/1/0933/4046/7564/files/xy_red.png?v=1753580333"
  }
];

